import {
   Box,
   Button,
   Checkbox,
   FormControl,
   Grid,
   MenuItem,
   Paper,
   TextField,
   Typography
} from '@material-ui/core'
import React, { useEffect, useState, useMemo } from 'react'
import { Autocomplete } from '@material-ui/lab'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import NavigationButtonTop from '../components/NavigationButtonTop'
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import GestionAprendizajeButton from '../components/GestionAprendizajeButton'
import TooltipInputError from 'components/toolTip/ToolTipInputError'
import PercentageField from 'components/form/PercentageField'

import { useStateValue } from 'context/store'
import configurationQuestionnaireStyles from './styles'
import iconQuestionnarie from '../../assets/icons/psychology_alt.png'
import { getFromApi, postToApi } from 'actions'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import utils from 'utils/utils'
import {
   closeSpinnerAction,
   openSpinnerAction
} from 'context/reducers/openSpinnerReducer'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'

const numbersOfQuizScore = () => {
   const numbers = []
   for (let i = 10; i <= 100; i += 10) {
      numbers.push(i)
   }
   return numbers
}

const defaultValues = {
   subdomainId: '',
   applicationId: '',
   attemptLimit: '',
   percentage: '',
   score: '',
   byDefault: false
}

function ConfigurationQuestionnaire({ setViewQuestionnarie }) {
   const [allActiveSubdomains, setAllActiveSubdomains] = useState([])
   const [allActiveApplications, setAllActiveApplications] = useState({})
   const [_, dispatch] = useStateValue()
   const { params, onClose, setModal } = usePortalModal()
   let history = useHistory()
   const classes = configurationQuestionnaireStyles()
   const {
      watch,
      handleSubmit,
      control,
      formState: { errors, isSubmitSuccessful, isSubmitted },
      trigger,
      setValue,
      reset
   } = useForm({
      defaultValues,
      mode: 'onChange'
   })

   const [byDefault, subdomainId] = watch(['byDefault', 'subdomainId'])

   function goToMundoMutual() {
      history.push('/dashboard/mutual-world')
   }

   const showExitModal = backButton => {
      const message = `Señor usuario, usted detendrá la creación de la configuración, ¿Desea continuar?`
      const onConfirm = backButton
         ? () => setViewQuestionnarie('')
         : goToMundoMutual
      setModal({ message, onConfirm })
   }

   // ------------- Fetch all Initial Active Subdomains  -----------------
   async function _getAllActiveSubdomains() {
      const url = `${process.env.REACT_APP_SUBDOMAIN_API}/subdomains/active`
      const searchedSubdomains = await getFromApi(url)
      setAllActiveSubdomains(searchedSubdomains)
   }

   const getAllActiveSubdomains = useApiRequest(
      _getAllActiveSubdomains,
      'Aplicaciones: Consultar Subdominios Activos'
   )

   // ------------- Fetch all Initial Applications for subdomain  -----------------
   async function _getAllActiveApplications(subdomainId) {
      !subdomainId && setAllActiveApplications([])
      const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/subdomain/${subdomainId?.code}/applications`
      const activeApplications = await getFromApi(url)
      setAllActiveApplications(activeApplications || [])
   }

   const getAllActiveApplications = useApiRequest(
      _getAllActiveApplications,
      'Funcionalidades: Consultar Aplicaciones Activas'
   )

   const subdomainsGrouped = useMemo(() => {
      const mapped = allActiveSubdomains.map(option => {
         const firstLetter = option?.name[0]?.toUpperCase()
         return {
            firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
            ...option
         }
      })
      return mapped.sort((a, b) => -b.firstLetter?.localeCompare(a.firstLetter))
   }, [allActiveSubdomains])

   const saveConfiguration = async ({
      subdomainId,
      applicationId,
      ...payload
   }) => {
      dispatch(openSpinnerAction())
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/configuration`
      try {
         const body = {
            ...payload,
            subdomainId: subdomainId?.id || 0,
            applicationId: applicationId?.id || 0
         }
         const resp = await postToApi(url, body)
         dispatch(openSnackBarAction(resp, 'success'))
      } catch (err) {
         dispatch(openSnackBarAction(err?.data?.message))
      } finally {
         dispatch(closeSpinnerAction())
      }
   }

   const onSubmit = async dataPayload => {
      await saveConfiguration(dataPayload)
   }

   useEffect(() => {
      getAllActiveSubdomains()
   }, [])

   useEffect(() => {
      subdomainId && getAllActiveApplications(subdomainId)
      setValue('applicationId', '')
   }, [subdomainId])

   useEffect(() => {
      if (byDefault) {
         setValue('subdomainId', '')
         setValue('applicationId', '')
      }
      isSubmitted && trigger()
   }, [byDefault])

   useEffect(() => {
      isSubmitSuccessful && reset(defaultValues)
   }, [isSubmitSuccessful, reset])

   return (
      <Grid
         style={{
            width: '90%',
            height: '100%',
            display: 'flex',
            padding: '0 3rem',
            gap: '2rem'
         }}
      >
         <NavigationButtonTop
            setShowComfirmationModal={() => showExitModal()}
            isConfirmationModal
            isButtonBack
            setView={() => showExitModal('backbutton')}
         />
         <div
            style={{
               width: '100%',
               display: 'flex',
               flexDirection: 'column',
               alignContent: 'center',
               justifyContent: 'center',
               padding: '0 7rem'
            }}
         >
            <Box
               sx={{
                  width: '80%',
                  display: 'flex',
                  gap: '1rem',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  height: '40px',
                  margin: '1rem'
               }}
            >
               <GestionAprendizajeButton
                  setViewQuestionnarie={setViewQuestionnarie}
               />
            </Box>
            <Paper className={classes.paper}>
               <Box
                  sx={{
                     width: '70%',
                     display: 'flex',
                     gap: '1rem',

                     alignContent: 'center',
                     alignItems: 'center',
                     height: '40px',
                     padding: '2rem 4rem'
                  }}
               >
                  <div className={classes.iconQuestionnarie}>
                     <img src={iconQuestionnarie} alt="" />
                  </div>{' '}
                  <h3>Crear Configuración</h3>
               </Box>
               <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid
                     style={{ padding: '1rem 7rem', marginBottom: '1.5rem' }}
                  >
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'flex-start',
                           gap: '2.5rem',
                           width: '100%'
                        }}
                     >
                        <FormControl fullWidth>
                           <Controller
                              name="subdomainId"
                              control={control}
                              rules={{
                                 required: {
                                    value: !byDefault,
                                    message:
                                       'El Campo Seleccionar subdominio es obligatorio'
                                 }
                              }}
                              render={({
                                 field: { ref, value, onChange, ...field }
                              }) => (
                                 <Autocomplete
                                    disabled={byDefault}
                                    options={subdomainsGrouped || []}
                                    getOptionSelected={(option, value) =>
                                       option?.id === value?.id
                                    }
                                    getOptionLabel={option =>
                                       option?.name
                                          ? utils.capitalizeFirstLetter(
                                               option?.name
                                            )
                                          : option?.name
                                    }
                                    value={value || null}
                                    groupBy={option => option.firstLetter}
                                    onChange={(_, data) => onChange(data)}
                                    name="subdomainId"
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          // getOptionSelected={(option, value) =>
                                          //    option.id === value.id
                                          // }
                                          label="Seleccionar subdominio"
                                          variant="outlined"
                                          error={errors?.subdomainId}
                                          helperText={
                                             errors?.subdomainId
                                                ? errors.subdomainId?.message
                                                : ''
                                          }
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                        <FormControl fullWidth>
                           <Controller
                              name="applicationId"
                              control={control}
                              rules={{
                                 required: {
                                    value: !byDefault,
                                    message:
                                       'El Campo Seleccionar aplicación es obligatorio'
                                 }
                              }}
                              render={({
                                 field: { ref, onChange, value, ...field }
                              }) => (
                                 <Autocomplete
                                    value={value}
                                    options={allActiveApplications}
                                    getOptionLabel={option => option?.name}
                                    renderOption={option => (
                                       <span key={option?.id}>
                                          {option?.name}
                                       </span>
                                    )}
                                    onChange={(_, data) => onChange(data)}
                                    disabled={!subdomainId}
                                    renderInput={params => (
                                       <TextField
                                          {...params}
                                          {...field}
                                          inputRef={ref}
                                          label="Seleccionar aplicación"
                                          variant="outlined"
                                          error={errors?.applicationId}
                                          helperText={
                                             errors?.applicationId
                                                ? errors?.applicationId?.message
                                                : ''
                                          }
                                       />
                                    )}
                                 />
                              )}
                           />
                        </FormControl>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'flex-start',
                           gap: '2.5rem',
                           width: '100%'
                        }}
                     >
                        <FormControl fullWidth>
                           <Controller
                              name="attemptLimit"
                              control={control}
                              rules={{
                                 required: {
                                    value: true,
                                    message:
                                       'El Campo Cantidad de intentos es obligatorio'
                                 },
                                 pattern: {
                                    value: /^[0-9]+$/,
                                    message:
                                       'El Tipo de Datos ingresado No es valido'
                                 },
                                 maxLength: {
                                    value: 2,
                                    message:
                                       'El Número de Caracteres NO es válido. '
                                 }
                              }}
                              render={({
                                 field: { value, onChange, onBlur },
                                 fieldState: { error }
                              }) => (
                                 <TextField
                                    label="Cantidad de intentos"
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    error={error}
                                    variant="outlined"
                                    InputProps={{
                                       endAdornment: error?.type ===
                                          'pattern' && (
                                          <TooltipInputError
                                             title={`El Campo Cantidad de intentos solo acepta números`}
                                          />
                                       )
                                    }}
                                    margin="normal"
                                    helperText={error ? error.message : ''}
                                 />
                              )}
                           />
                        </FormControl>
                        <FormControl fullWidth style={{ paddingTop: 15 }}>
                           <Controller
                              name="percentage"
                              control={control}
                              rules={{
                                 required: {
                                    value: true,
                                    message:
                                       'El Campo Porcentaje de cumplimiento es obligatorio'
                                 },
                                 pattern: {
                                    value: /^[0-9]+$/,
                                    message:
                                       'El Tipo de Datos ingresado No es valido'
                                 },
                                 maxLength: {
                                    value: 3,
                                    message:
                                       'El Número de Caracteres NO es válido.'
                                 }
                              }}
                              render={({
                                 field: { value, onChange },
                                 fieldState: { error }
                              }) => (
                                 <PercentageField
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(error)}
                                    label="Porcentaje de cumplimiento"
                                    helperText={error ? error.message : ''}
                                 />
                              )}
                           />
                        </FormControl>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'flex-start',
                           gap: '2.5rem',
                           width: '47.5%'
                        }}
                     >
                        <FormControl fullWidth>
                           <Controller
                              name="score"
                              control={control}
                              rules={{
                                 required: {
                                    value: true,
                                    message:
                                       'El Campo Puntaje de cuestionario es obligatorio'
                                 },
                                 pattern: {
                                    value: /^[0-9]+$/,
                                    message:
                                       'El Tipo de Datos ingresado No es valido'
                                 },
                                 maxLength: {
                                    value: 3,
                                    message:
                                       'El Número de Caracteres NO es válido.'
                                 }
                              }}
                              render={({
                                 field: { value, onChange, onBlur },
                                 fieldState: { error }
                              }) => (
                                 <TextField
                                    select
                                    label="Puntaje de cuestionario"
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    error={errors?.score}
                                    variant="outlined"
                                    margin="normal"
                                    multiline
                                    InputProps={{
                                       endAdornment: errors?.score?.type ===
                                          'pattern' && (
                                          <TooltipInputError
                                             title={`El Puntaje de cuestionario solo acepta números`}
                                          />
                                       )
                                    }}
                                    helperText={
                                       errors?.score
                                          ? errors.score?.message
                                          : ''
                                    }
                                 >
                                    {numbersOfQuizScore().map(numero => (
                                       <MenuItem key={numero} value={numero}>
                                          {numero}
                                       </MenuItem>
                                    ))}
                                 </TextField>
                              )}
                           />
                        </FormControl>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '2.5rem',
                           width: '100%',
                           justifyContent: 'flex-end'
                        }}
                     >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                           <Typography style={{ color: '#8A8FAB' }}>
                              Default
                           </Typography>
                           <Controller
                              name="byDefault"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                 <Checkbox
                                    color="primary"
                                    checked={value}
                                    onChange={onChange}
                                 />
                              )}
                           />
                        </Box>
                     </Box>
                  </Grid>
                  <Box
                     sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        height: '70px',
                        width: '100%',
                        background: '#3264DC0F 0% 0% no-repeat'
                     }}
                  >
                     <div
                        style={{
                           width: '100%',
                           display: 'flex',
                           gap: '1rem',
                           justifyContent: 'flex-end',
                           alignContent: 'center',
                           padding: '1rem 7rem'
                        }}
                     >
                        <Button
                           variant="outlined"
                           color="primary"
                           onClick={() => showExitModal('backbutton')}
                        >
                           CANCELAR
                        </Button>
                        <Button
                           variant="contained"
                           color="primary"
                           type="submit"
                        >
                           GUARDAR
                        </Button>
                     </div>
                  </Box>
               </form>
            </Paper>
         </div>
         <PortalModal params={params} onClose={onClose} />
      </Grid>
   )
}

export default ConfigurationQuestionnaire
